import React from 'react'
import { InputLabelText } from 'components/generic/Input/styles'
import { Input, Label } from './TextInput.styles'

export const LABEL_POSITION = {
  ABOVE: 'above',
  RIGHT: 'right',
  LEFT: 'left',
}

export type TextInputProps = JSX.IntrinsicElements['input'] & {
  label?: string
  labelPosition?: string
  isValid?: boolean
}

const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  (
    { label = '', isValid = true, labelPosition = LABEL_POSITION.ABOVE, children, ...rest },
    ref: any
  ) => {
    return (
      <Label labelPosition={labelPosition}>
        <InputLabelText>{label}</InputLabelText>
        {children || <Input type='text' ref={ref} isValid={isValid} {...rest} />}
      </Label>
    )
  }
)

// Need this to get around false positive lint issue
// see https://github.com/yannickcr/eslint-plugin-react/issues/2269
TextInput.displayName = 'TextInput'

export default TextInput
